import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import icon_warning from "../../assets/images/icons/icon-warning.svg";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  formControl: {
    margin: theme.spacing(0)
  }
}));
const FilterDistance = props => {
  const { distanceFilter, expandView, resetComponent, currentLocation } = props;
  const classes = useStyles();
  const [state, setState] = useState({
    miles25: false,
    miles50: false,
    miles100: false,
    miles150: false,
    miles250: false,
    miles500: false
  });

  const handleChange = event => {
    //toggle off checkmarks and set selected to checked
    setState({
      miles25: false,
      miles50: false,
      miles100: false,
      miles150: false,
      miles250: false,
      miles500: false,
      [event.target.name]: event.target.checked
    });
  };

  useEffect(() => {
    if (resetComponent) {
      setState({
        miles25: false,
        miles50: false,
        miles100: false,
        miles150: false,
        miles250: false,
        miles500: false
      });
    }
  }, [resetComponent]);

  useEffect(() => {
    //console.log(state);

    distanceFilter(state);
  }, [state]);

  const { miles25, miles50, miles100, miles150, miles250, miles500 } = state;

  return (
    <div style={{ width: "100%" }}>
      {currentLocation ? (
        <FormControl
          style={{ width: "100%" }}
          component="fieldset"
          className={classes.formControl}
        >
          {expandView ? (
            <FormLabel component="legend">DISTANCE</FormLabel>
          ) : null}
          <span className="accordion-subhead">ORGANIZATIONS WITHIN</span>
          <FormGroup className="filterDistanceGroup">
            <FormControlLabel
              control={
                <Checkbox
                  checked={miles25}
                  onChange={handleChange}
                  name="miles25"
                />
              }
              label="25 miles"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={miles50}
                  onChange={handleChange}
                  name="miles50"
                />
              }
              label="50 miles"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={miles100}
                  onChange={handleChange}
                  name="miles100"
                />
              }
              label="100 miles"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={miles150}
                  onChange={handleChange}
                  name="miles150"
                />
              }
              label="150 miles"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={miles250}
                  onChange={handleChange}
                  name="miles250"
                />
              }
              label="250 miles"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={miles500}
                  onChange={handleChange}
                  name="miles500"
                />
              }
              label="500 miles"
            />
          </FormGroup>
        </FormControl>
      ) : (
        <div className="warning" style={{ paddingLeft: "7px", width: "95%" }}>
          <img
            alt="Blue exlamation mark inside pink outline"
            width="28"
            height="28"
            src={icon_warning}
          />
          <div style={{ display: "inline-block", width: "90%" }}>
            To filter results by distance please turn on geolocation in the
            privacy settings of your internet browser.
          </div>
        </div>
      )}
    </div>
  );
};
export default FilterDistance;
